import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ComponentsService } from '../components.service';

@Injectable({
    providedIn: 'root',
})
export class ProductManSettingsGuard implements CanActivate {
    constructor(
        private readonly service: ComponentsService,
        private readonly router: Router,
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        const isSuperAdmin = !!this.service.getUsersPerm().superAdmin;

        if (!isSuperAdmin) {
            return this.router.navigate(['/home']);
        }

        return true;
    }
}
